import getApiClient from 'src/utils/getApiClient'
import { ApiCitiesParamsGet, ApiCitiesResponseGet } from 'src/layouts/core-layout/components/CoreSearch/api/apiCities.types'

const apiClient = getApiClient()

export default {
  get(params: ApiCitiesParamsGet) {
    return apiClient.get<ApiCitiesResponseGet>('/api/town/selector/', {
      params,
    })
  },
}
